import errors from 'src/app/pages/core/utils/errorCodes';
import {
  BLOCKCHAINS,
  BLOCKCHAINS_NAMES,
  IBlockchainStatus,
  IFeeEstimate,
} from './../../../../models/Crypto';
import { Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from '../../../../services/api.service';
import { AuthService } from '../../../../abstraction/auth.service';
import { CryptoService } from '../../../../abstraction/crypto.service';
import { DataLayerService } from '../../../../services/utils/data-layer.service';
import { ITransaction } from '../../../../models/Transactions';
import { WithdrawTabComponent } from '../withdraw-tab.component';
import { ErrorHandlingService } from 'src/app/pages/core/services/utils/error-handling.service';
import { ICryptoAccount, TWOFA_STATUS } from 'src/app/pages/core/models/User';
import IErrorData from '../../../../utils/IErrorData';
import BigNumber from 'bignumber.js';
import { AddCryptoAccountComponent } from '../../../profile/accounts/add-crypto-account/add-crypto-account.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Utils } from 'src/app/pages/core/utils/Utils';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';
interface WithdrawCost {
  bnb?: {
    code: string;
    result: IFeeEstimate;
    isInternalAddress?: boolean;
    isChargeAddress?: boolean;
  };
  eth: {
    code: string;
    result: IFeeEstimate;
    isInternalAddress?: boolean;
    isChargeAddress?: boolean;
  };
  terra: {
    code: string;
    result: IFeeEstimate;
    isInternalAddress?: boolean;
    isChargeAddress?: boolean;
  };
  terra2: {
    code: string;
    result: IFeeEstimate;
    isInternalAddress?: boolean;
    isChargeAddress?: boolean;
  };
  polygon: {
    code: string;
    result: IFeeEstimate;
    isInternalAddress?: boolean;
    isChargeAddress?: boolean;
  };
}

@Component({
  selector: 'app-withdraw-crypto',
  templateUrl: './withdraw-crypto.component.html',
  styleUrls: ['./withdraw-crypto.component.scss'],
})
export class WithdrawCryptoComponent implements OnInit, OnDestroy {
  @ViewChild('addressSelect') addressSelect;
  @Output() changeCloseEvent: EventEmitter<boolean> = new EventEmitter();
  blockchains: string[] = [];
  metamaskErrorMessage = '';
  loading = false;
  cryptoWithdrawType: number = null; // Regular: 0, Inteligente: 1, Binance: 2
  bscDisabled: boolean;
  ethDisabled: boolean;
  terraDisabled: boolean;
  terra2Disabled: boolean;
  addressBookOpened: boolean;
  cryptoSelected: FormControl = new FormControl('USDT');
  blockchainSelected: FormControl = new FormControl('', [Validators.required]);
  address: FormControl = new FormControl('', [Validators.required]);
  transferNetwork = '';
  quantity: FormControl = new FormControl('', [Validators.required]);
  userCryptoAccounts: ICryptoAccount[] = [];
  emailVerificationCode: FormControl = new FormControl('', [Validators.required]);
  askForAddress;
  chainValue = {
    BSC: 1,
    ERC20: 0,
    CW20: 2,
    terra2: 3,
  };
  internalWithdraw = false;
  isChargeAddress = false;

  showErrorText = '';
  showVerificationErrorText = false;
  showResendBtn = false;
  countDownMinute = 5;
  countDownSecond = 60;

  verificationIntervalRef: any;
  feeIntervalRef: any;
  isProcessingTransaction = false;

  cryptoList: any = {};
  availableCoins: string[];

  costToShow: WithdrawCost;

  usdcCost: WithdrawCost;
  daiCost: WithdrawCost;

  finalCost = 0;

  loadingGetCost = false;
  finalAmount = 0;

  withdrawRequest: ITransaction;
  withdrawStatus: number;

  blockTransferBtn = false;

  controlNames = {
    address: this.address,
    cryptoSelected: this.cryptoSelected,
    blockchainSelected: this.blockchainSelected,
  };

  accountExist = false;

  private blockchainStatuses: IBlockchainStatus[] = [];

  pin = '';
  twoFAStatus = false;
  invalidCode = false;
  isValidPin = false;
  resendEmail = false;
  params;

  constructor(
    public api: ApiService,
    public matDialog: MatDialog,
    public dataS: DataLayerService,
    public cryptoService: CryptoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<WithdrawTabComponent>,
    private router: Router,
    private errorHandler: ErrorHandlingService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.blockchains = this.cryptoService.blockchains;
    this.cryptoWithdrawType = 0;
    this.cryptoList = {
      usdc: 'USD Coin',
      dai: 'DAI',
      eth: 'Ethereum',
    };

    this.cryptoService.getWithdrawableCoins().subscribe({
      next: (coins) => {
        this.availableCoins = coins;
      },
    });

    this.blockchainSelected.valueChanges.subscribe({
      next: () => {
        clearInterval(this.feeIntervalRef);
        this.getCost(this.cryptoSelected.value, this.address.value);
      },
    });

    this.address.valueChanges.subscribe({
      next: () => {
        clearInterval(this.feeIntervalRef);
        this.getCost(this.cryptoSelected.value, this.address.value);
      },
    });

    this.userCryptoAccounts = this.authService.loggedUser.cryptoAccounts;

    this.cryptoService.getBlockchainStatus().subscribe((res) => {
      this.blockchainStatuses = res;
    });

    this.twoFAStatus = this.authService.loggedUser.security.twoFA.status === TWOFA_STATUS.ACTIVE;
  }

  blockchainsNames(blockchain) {
    const names = {
      0: 'Ethereum',
      1: 'BNB Chain (BEP-20)',
      2: 'Terra Classic',
      3: 'Terra',
      4: 'Polygon',
    };
    return names[BLOCKCHAINS[blockchain]];
  }

  blockchainsByCoin(): string[] {
    let availableBlockchains = [];
    let ticker = this.cryptoSelected.value;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    }
    this.blockchainStatuses.forEach((blockchain) => {
      if (blockchain.coins[ticker] && blockchain.type === 1) {
        if (blockchain.chain in BLOCKCHAINS)
          availableBlockchains.push(BLOCKCHAINS[blockchain.chain]);
      }
    });
    return availableBlockchains;
  }

  getAccountsByNetwork() {
    let accounts = this.userCryptoAccounts;
    if (this.bscDisabled) {
      accounts = accounts.filter((account) => account.chain !== this.chainValue.BSC);
    }
    if (this.ethDisabled) {
      accounts = accounts.filter((account) => account.chain !== this.chainValue.ERC20);
    }
    if (this.terraDisabled) {
      accounts = accounts.filter((account) => account.chain !== this.chainValue.CW20);
    }
    if (this.terra2Disabled) {
      accounts = accounts.filter((account) => account.chain !== this.chainValue.terra2);
    }
    return accounts;
  }

  getNameByChain(chain) {
    const networkName = {
      0: 'ethereum',
      1: 'bsc',
      2: 'terra',
      3: 'terra2',
      4: 'polygon',
    };
    return networkName[chain];
  }

  getBlockchainStatus(chain: number) {
    let ticker = this.cryptoSelected.value;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    }
    return (
      this.blockchainStatuses.find((blockchain) => {
        return chain === blockchain.chain && blockchain.type === 1;
      })?.coins[ticker as string] || false
    );
  }

  addressSelectOpened(isOpened) {
    if (!isOpened) {
      this.addressBookOpened = false;
    }
  }

  getCost(coin: string, wallet: string) {
    if (this.loadingGetCost) {
      return;
    }
    this.loadingGetCost = true;
    this.costToShow = null;
    if (coin === 'USDC') {
      this.transferNetwork = 'ERC20';
    }
    let coinRequest = coin;
    if (coinRequest === 'LUNC') {
      coinRequest = 'LUNA';
    } else if (coinRequest === 'LUNA') {
      coinRequest = 'LUNA2';
    } else if (coinRequest === 'USTC') {
      coinRequest = 'UST';
    }
    this.cryptoService.getWithdrawCost(coinRequest, wallet).subscribe(
      (res) => {
        this.costToShow = res;
        if (
          this.costToShow?.bnb.isChargeAddress ||
          this.costToShow?.eth.isChargeAddress ||
          this.costToShow?.terra.isChargeAddress ||
          this.costToShow?.terra2.isChargeAddress ||
          this.costToShow?.polygon.isChargeAddress
        ) {
          this.isChargeAddress = true;
        } else {
          this.isChargeAddress = false;
        }
        const startTime = new Date().getTime();
        this.setFeeTimer(startTime);
        this.loadingGetCost = false;
        this.errorIfInternalTransfer();

        if (this.resendEmail) {
          this.resendEmailWithUpdateCost(); // Reenvía el mail con el costo actualizado
        }
      },
      (error) => {
        console.log(error);
        this.loadingGetCost = false;
        if (error.internalStatus === 'INVALID_ADDRESS') {
          this.address.setErrors({ invalidAddress: true });
        } else {
          const errorMessages = this.errorHandler.handleError(error);
          this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: errorMessages.title,
              content: errorMessages.body,
              errorCode: errorMessages.errorCode,
              isError: true,
            },
          });
        }
      },
    );
  }

  ngOnDestroy(): void {
    clearInterval(this.feeIntervalRef);
  }

  setMaxAmount() {
    this.quantity.setValue(this.getAvailableAmount().toString().replace('.', ','));
    this.quantity.updateValueAndValidity();
  }

  openAddressSelector() {
    setTimeout(() => {
      this.addressSelect.trigger.nativeElement.click();
    }, 100);
  }

  getFinalFee() {
    if (this.isChargeAddress) {
      return this.quantity.value || '0';
    }
    if (this.costToShow) {
      if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.ETHEREUM) {
        return this.costToShow.eth?.result?.feeInRequestedCoin || 0;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.BSC) {
        return this.costToShow.bnb?.result?.feeInRequestedCoin || 0;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA) {
        return this.costToShow.terra?.result?.feeInRequestedCoin || 0;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA2) {
        return this.costToShow.terra2?.result?.feeInRequestedCoin || 0;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.POLYGON) {
        return this.costToShow.polygon?.result?.feeInRequestedCoin || 0;
      }
    }
    return 0;
  }

  errorIfInternalTransfer() {
    if (this.isChargeAddress == false && this.internalWithdraw == true) {
      this.showErrorText =
        'Las transferencias internas se encuentran momentáneamente deshabilitadas.';
    } else {
      this.showErrorText = '';
    }
  }

  checkAddressValidity() {
    const value = this.address.value;
    if (value) {
      if (
        this.blockchainSelected.value === BLOCKCHAINS_NAMES.ETHEREUM ||
        this.blockchainSelected.value === BLOCKCHAINS_NAMES.BSC ||
        this.blockchainSelected.value === BLOCKCHAINS_NAMES.POLYGON
      ) {
        return value.match(/^(0x)?[0-9a-f]{40}$/i);
      } else {
        return value.toLowerCase().startsWith('terra');
      }
    }
    return false;
  }

  getFinalWithdraw(): string {
    let finalAmountValue = new BigNumber(0);
    const quantity = new BigNumber((this.quantity.value as string).replace(',', '.'));

    if (this.costToShow && this.quantity.valid) {
      if (
        (this.blockchainSelected.value === BLOCKCHAINS_NAMES.ETHEREUM &&
          this.costToShow?.eth &&
          quantity.isGreaterThan(new BigNumber(this.costToShow.eth?.result?.feeInRequestedCoin))) ||
        0
      ) {
        finalAmountValue = quantity.minus(
          new BigNumber(this.costToShow.eth.result.feeInRequestedCoin),
        );
      } else if (
        (this.blockchainSelected.value === BLOCKCHAINS_NAMES.BSC &&
          this.costToShow?.bnb &&
          quantity.isGreaterThan(new BigNumber(this.costToShow.bnb?.result?.feeInRequestedCoin))) ||
        0
      ) {
        finalAmountValue = quantity.minus(
          new BigNumber(this.costToShow.bnb.result.feeInRequestedCoin),
        );
      } else if (
        (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA &&
          this.costToShow?.terra &&
          quantity.isGreaterThan(
            new BigNumber(this.costToShow.terra?.result?.feeInRequestedCoin),
          )) ||
        0
      ) {
        finalAmountValue = quantity.minus(
          new BigNumber(this.costToShow.terra.result.feeInRequestedCoin),
        );
      } else if (
        (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA2 &&
          this.costToShow?.terra2 &&
          quantity.isGreaterThan(
            new BigNumber(this.costToShow.terra2?.result?.feeInRequestedCoin),
          )) ||
        0
      ) {
        finalAmountValue = quantity.minus(
          new BigNumber(this.costToShow.terra2.result.feeInRequestedCoin),
        );
      } else if (
        (this.blockchainSelected.value === BLOCKCHAINS_NAMES.POLYGON &&
          this.costToShow?.polygon &&
          quantity.isGreaterThan(
            new BigNumber(this.costToShow.polygon?.result?.feeInRequestedCoin),
          )) ||
        0
      ) {
        finalAmountValue = quantity.minus(
          new BigNumber(this.costToShow.polygon.result.feeInRequestedCoin),
        );
      }
    }
    if (this.internalWithdraw) {
      finalAmountValue = finalAmountValue.minus(new BigNumber(finalAmountValue.multipliedBy(0.01)));
    }
    this.finalAmount = finalAmountValue.toNumber();
    return finalAmountValue.toString();
  }

  getAvailableAmount(): string {
    let ticker = this.cryptoSelected.value;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    }
    const coinBalance = this.authService.loggedUser.balance.crypto[ticker];
    if (coinBalance) {
      return Utils.roundDownForOperation(coinBalance.amount).toString();
    } else {
      return '0';
    }
  }

  isValidWithdraw() {
    const amount = new BigNumber((this.quantity.value as string).replace(',', '.'));
    const balance = new BigNumber(this.getAvailableAmount() as string);
    return this.address.valid && this.finalAmount > 0 && amount.isLessThanOrEqualTo(balance);
  }

  backToStepTwo() {
    if (this.verificationIntervalRef != null) {
      clearInterval(this.verificationIntervalRef);
    }
    if (this.feeIntervalRef != null) {
      this.getCost(this.cryptoSelected.value, this.address.value);
    }
    this.dataS.withdrawStep = 2;
    this.changeCloseEvent.emit(false);
  }

  // PRE WITHDRAW
  confirmBtnClicked() {
    let ticker = this.cryptoSelected.value;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    }
    if (!this.checkAddressValidity()) {
      this.address.setErrors({ invalidAddress: true });
      return;
    }

    this.showErrorText = '';
    const amount = (
      this.isChargeAddress ? this.getFinalWithdraw() : (this.quantity.value as string)
    ).replace(',', '.');
    if (this.isValidWithdraw()) {
      const params = {
        address: this.address.value as string,
        amount,
        coin: ticker as string,
        chain: BLOCKCHAINS[this.blockchainSelected.value],
        costCode: '',
      };
      this.params = params;
      if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.BSC) {
        this.finalCost = +this.costToShow.bnb.result.feeInUSD;
        params.costCode = this.costToShow.bnb.code;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.ETHEREUM) {
        this.finalCost = +this.costToShow.eth.result.feeInUSD;
        params.costCode = this.costToShow.eth.code;
        // if(!environment.production){
        //   params.coin = 'WEEZ';
        // }
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA) {
        this.finalCost = +this.costToShow.terra.result.feeInUSD;
        params.costCode = this.costToShow.terra.code;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA2) {
        this.finalCost = +this.costToShow.terra2.result.feeInUSD;
        params.costCode = this.costToShow.terra2.code;
      } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.POLYGON) {
        params.costCode = this.costToShow.polygon.code;
      }
      this.cryptoService.sendWithdrawEmailVerification(params).subscribe(
        (res) => {
          clearInterval(this.feeIntervalRef);
          this.dataS.withdrawStep = 3;
          this.changeCloseEvent.emit(true);
          if (this.isChargeAddress) {
            (<any>this.withdrawRequest) = params;
            this.dataS.withdrawStep = 4;
          }
        },
        (error) => {
          console.log('Error ', error);
          this.blockTransferBtn = true;
          const errorData: IErrorData = this.errorHandler.handleErrorCryptoWithdrawals(error);
          this.matDialog
            .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: errorData.title,
                content: errorData.body,
                errorCode: errorData.errorCode,
                isError: true,
              },
            })
            .afterClosed()
            .subscribe({
              next: () => {
                this.blockTransferBtn = false;
              },
            });
        },
      );
    } else {
      this.showErrorText = `Los campos de dirección y cantidad de ${ticker} son obligatorios.`;
    }
  }

  setFeeTimer(startTime: number) {
    this.feeIntervalRef = setInterval(() => {
      const currentTime = new Date().getTime();
      const distance = currentTime - startTime;
      this.countDownSecond = 60 - Math.floor((distance % (1000 * 60)) / 1000);
      if (distance >= 60000) {
        clearInterval(this.feeIntervalRef);
        this.getCost(this.cryptoSelected.value, this.address.value);
      }
    }, 1000);
  }

  getErrorMessage(input: string) {
    const keys = Object.keys(this.controlNames[input].errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[Object.keys(this.controlNames[input].errors)[0]];
  }

  getFormattedEmail(mail: string) {
    const splitMail = mail.split('@');
    const firstTwoLetter = splitMail[0].slice(0, 3);
    const lastTwoLetter = splitMail[0].slice(-2);
    return firstTwoLetter + '****' + lastTwoLetter + '@' + splitMail[1];
  }

  getFormattedAddress(address: string): string {
    let shortAddress = address.substring(0, 10) + '...' + address.substring(28, address.length);
    return shortAddress;
  }

  // CONFIRM WITHDRAW
  sendBtnClicked() {
    this.isProcessingTransaction = true;
    this.showErrorText = '';
    this.invalidCode = false;
    if (this.isValidPin) {
      clearInterval(this.verificationIntervalRef);
      this.cryptoService.withdrawCrypto(this.pin).subscribe(
        (res) => {
          clearInterval(this.feeIntervalRef);
          this.accountExist = this.checkAccountExist();
          this.withdrawRequest = res;
          this.withdrawStatus = res.status;
          this.dataS.withdrawStep = 4;
          this.changeCloseEvent.emit(false);
          this.isProcessingTransaction = false;
        },
        (error) => {
          console.log('Error crypto withdraw ', error);
          this.isProcessingTransaction = false;
          const errorData: IErrorData = this.errorHandler.handleErrorCryptoWithdrawals(error);
          this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: errorData.title,
              content: errorData.body,
              errorCode: errorData.errorCode,
              isError: true,
            },
          });
          this.pin = '';
          this.invalidCode = true;
        },
      );
    } else {
      this.isProcessingTransaction = false;
      this.showErrorText = 'Ingresá un código para continuar.';
    }
  }

  // resendBtnClicked() {
  //   // API resend verification code
  //   this.showResendBtn = false;
  //   this.countDownMinute = 5;
  //   const newStartTime = new Date().getTime();
  //   this.setTimer(newStartTime);
  // }

  historyBtnClicked() {
    // if ( this.transferNetwork === 'BSC' ){
    //   window.open(environment.binanceTransactionBaseUrl + this.withdrawRequest?.hash);
    // } else if ( this.transferNetwork === 'ERC20' ){
    // window.open(environment.ethereumTransactionBaseUrl + this.withdrawRequest?.hash);
    // }
    this.dialogRef.close(true);
    this.router.navigate(['/history']);
  }

  parseNumberToCurrencyString(value: number) {
    const valueStr = value.toString();

    if (!valueStr) {
      return '0';
    }
    const arr = valueStr.split('.');
    if (arr.length > 1) {
      arr[1] = arr[1].substr(0, 10);
    }
    arr[0] = arr[0]
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g)
      .join('.')
      .split('')
      .reverse()
      .join('');
    return arr.join(',');
  }

  parseCurrencryToNumber(str: string | number): number {
    if (typeof str === 'number') {
      return str;
    }
    if (!str) {
      return 0;
    }
    if (str.split('.').slice(-1)[0].length < 11) {
      return parseFloat(str);
    } else {
      if (this.cryptoSelected.value !== 'DAI') {
        return Number(str.split('.').join('').split(',').join('.'));
      }
      return parseFloat(str.split('.').join('').split(',').join('.'));
    }
  }

  resend() {
    this.resendEmail = true;
    this.getCost(this.cryptoSelected.value, this.address.value);
  }

  resendEmailWithUpdateCost() {
    this.resendEmail = false;
    if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.BSC) {
      this.finalCost = +this.costToShow.bnb.result.feeInUSD;
      this.params.costCode = this.costToShow.bnb.code;
    } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.ETHEREUM) {
      this.finalCost = +this.costToShow.eth.result.feeInUSD;
      this.params.costCode = this.costToShow.eth.code;
    } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA) {
      this.finalCost = +this.costToShow.terra.result.feeInUSD;
      this.params.costCode = this.costToShow.terra.code;
    } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.TERRA2) {
      this.finalCost = +this.costToShow.terra2.result.feeInUSD;
      this.params.costCode = this.costToShow.terra2.code;
    } else if (this.blockchainSelected.value === BLOCKCHAINS_NAMES.POLYGON) {
      this.finalCost = +this.costToShow.polygon.result.feeInUSD;
      this.params.costCode = this.costToShow.polygon.code;
    }
    this.cryptoService.sendWithdrawEmailVerification(this.params).subscribe(
      (res) => {
        clearInterval(this.feeIntervalRef);
        this.dataS.withdrawStep = 3;
        if (this.isChargeAddress) {
          (<any>this.withdrawRequest) = this.params;
          this.dataS.withdrawStep = 4;
        }
      },
      (error) => {
        console.log('Error ', error);
        this.blockTransferBtn = true;
        const errorData: IErrorData = this.errorHandler.handleErrorCryptoWithdrawals(error);
        this.matDialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: errorData.title,
              content: errorData.body,
              errorCode: errorData.errorCode,
              isError: true,
            },
          })
          .afterClosed()
          .subscribe({
            next: () => {
              this.blockTransferBtn = false;
            },
          });
      },
    );
  }

  checkAccountExist(): boolean {
    if (
      this.authService.loggedUser.cryptoAccounts?.filter(
        (account) => account.address?.toLowerCase() === this.address.value.toLowerCase(),
      ).length
    ) {
      return true;
    }
    return false;
  }

  addAcount() {
    this.dialog
      .open(AddCryptoAccountComponent, {
        panelClass: 'modal-add-account',
        data: {
          title: `Agregá una cuenta en Crypto`,
          address: this.address.value,
          network: this.transferNetwork,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.setErrorHandler(res);
        }
      });
  }

  setErrorHandler(error: HttpErrorResponse) {
    this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
      panelClass: 'modal-container',
      data: this.errorHandler.handleAccountError(error),
    });
  }

  fillCode(value: string) {
    this.pin = value;
    if (this.pin.length === 6) {
      this.isValidPin = true;
    } else {
      this.isValidPin = false;
    }
  }
}
